import { Model, Attr, HasMany, HasOne } from 'spraypaint';
import { FaunaSurvey, User } from '@/api';
import ApplicationRecord from '../ApplicationRecord';

@Model()
export default class FaunaSurveyImport extends ApplicationRecord {
  static jsonapiType = 'fauna-survey-imports';

  static listHeaders() {
    return [
      {
        text: 'ID',
        value: 'id',
        width: 100,
      },
      {
        text: 'Name',
        value: 'name',
      },
      {
        text: 'Created',
        value: 'createdAt',
      },
    ];
  }

  static scopeFactory() {
    return FaunaSurveyImport.includes([]);
  }

  // send to csv_import

  @Attr() createdAt: string;

  @Attr() success: boolean;

  @Attr() header: string[];

  @Attr() importErrors: CSVImportError[];

  @HasMany() createdFaunaSurveys: FaunaSurvey[];

  @HasOne() createdBy: User;
}
